import { Stack, Skeleton } from '@mui/material';

export const ButtonsSkeleton = () => (
  <Stack direction="row" justifyContent="flex-end" gap="1rem">
    <Skeleton variant="rectangular" sx={{ borderRadius: '0.25rem' }} width={137} height={36} />
    <Skeleton variant="rectangular" sx={{ borderRadius: '0.25rem' }} width={108} height={36} />
  </Stack>
);
